module.exports = __webpack_public_path__ + "static/media/new_year.82f6dd4a.jpg";